import * as React from 'react';
import { ErrorMessage, ErrorMessageLink } from '@helpcenter/error-message';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl, FormattedMessage } from 'react-intl-next';
import type { FormErrors } from '../types';
import messages from './messages';
import { ERROR_REASON_KEYS } from 'rest/request-create/types';
interface FormErrorMessageProps {
    errors: FormErrors;
}

// This is a class component so it can be used inside <Autofocus />
export class FormErrorMessage extends React.Component<FormErrorMessageProps & WrappedComponentProps> {
    render() {
        const { errors, intl } = this.props;
        const { errorReasonKey } = errors;
        const {
            errorMessageTitle,
            errorMessageTitleForBot,
            errorMessageOfflineText,
            errorMessageText,
            errorMessageContactLink,
            errorMessageForInternalError,
        } = messages;
        const submissionError = errors.submissionError;
        const errorTitleDescriptor =
            errorReasonKey === ERROR_REASON_KEYS.RECAPTCHA_ERROR ? errorMessageTitleForBot : errorMessageTitle;
        const errorTitle = intl.formatMessage(errorTitleDescriptor);
        let errorMessage;
        const hasTraceId = !!errors.traceId;
        if (submissionError && 'isOfflineError' in submissionError && submissionError.isOfflineError) {
            errorMessage = intl.formatMessage(errorMessageOfflineText);
        } else if (hasTraceId && submissionError && 'isGeneric' in submissionError && submissionError.isGeneric) {
            errorMessage = (
                <FormattedMessage
                    {...errorMessageText}
                    values={{
                        contactLink: (
                            <ErrorMessageLink
                                href={errors.contactLink}
                                target="_blank"
                                actionSubjectId="errorMessageContactLink"
                            >
                                <FormattedMessage {...errorMessageContactLink} />
                            </ErrorMessageLink>
                        ),
                    }}
                />
            );
        } else {
            // pre-translated error message from the backend
            errorMessage = submissionError && 'errorMessage' in submissionError && submissionError.errorMessage;
        }

        if (!errorMessage && !hasTraceId) {
            errorMessage = intl.formatMessage(errorMessageForInternalError);
        }

        return <ErrorMessage title={errorTitle} message={errorMessage} />;
    }
}

export default injectIntl(FormErrorMessage);
